import {useEffect, useState} from "react";

export const ProtectedRoute = ({LoadingComponent, Component, getBearerToken, CampaignsMaintenance}) => {
    const [token, setToken] = useState();
    const isInMaintenance = process.env.REACT_APP_IS_IN_MAINTENANCE === 'true';
    const Page = isInMaintenance ? CampaignsMaintenance : Component;

    useEffect(() => {
        getBearerToken().then((authenticationToken) => setToken(authenticationToken))
    }, [])

    return token ? <Page/> : <LoadingComponent/>
}